import React from "react";
import Cards from "./Cards";
import About from "./About";

const Home = () => {
  return (
    <div>
      <About />
      <Cards />
    </div>
  );
};

export default Home;

// import React from "react";

// const Home = () => {
//   return <div>My Home Page</div>;
// };

// export default Home;
